/**
 * Dummy function to use in replacement of Apollo Client's ``gql``.
 *
 * This is used to have Apollo VSCode extension IntelliSense through the schema used in `apollo.config.js`.
 *
 * Refer to the [GraphQL IntelliSense](https://github.com/bariendo/medplum-provider/blob/acacfd29a9f0e8122446cff737fc096856ec2000/docs/graphql-intellisense.md) docs for more information.
 * @see https://github.com/bariendo/medplum-provider/blob/acacfd29a9f0e8122446cff737fc096856ec2000/docs/graphql-intellisense.md
 */
export const gql = String.raw;
